module.exports = __webpack_public_path__ + "static/media/3.1f8c01d5.png";